import { SIDE_MENU_EVENTS } from '@src/components/menu/sideMenu';

export const typeIdLand = {
  '1': 'A1',
  '2': 'B2',
  '3': 'C3',
  '4': 'D4',
  '5': 'E5',
  '6': 'F6',
  '7': 'G7',
  '8': 'H8',
};

export interface NFT {
  land: LandNFT;
  marketplace: MarketplaceNFT;
}

export const formatsMarketplaceNft = {
  MODEL: SIDE_MENU_EVENTS.LIBRARY_3D,
  IMAGE: SIDE_MENU_EVENTS.IMAGE_PLANE,
  AUDIO: SIDE_MENU_EVENTS.AUDIOS,
  VIDEO: SIDE_MENU_EVENTS.VIDEO_PLANE,
};

type LandMetadata = {
  collectionBannerImageMediaType: string;
  collectionBannerImageUrl: string;
  collectionDescription: string;
  collectionExternalURL: string;
  collectionName: string;
  collectionSquareImageMediaType: string;
  collectionSquareImageUrl: string;
  districtId: string;
  districtName: string;
  editionMax: string;
  editionName: string;
  externalURL: string;
  imageMimeType: string;
  imageUrl: string;
  url: string;
  videoMimeType: string;
  videoUrl: string;
};

type LandNFT = {
  id?: string;
  metadata?: LandMetadata;
  typeID?: string;
  uuid?: string;
};

type MarketplaceNFT = {
  categoryId: string;
  creator: string;
  description: string;
  fileName: string;
  fileIPFS: string;
  format: 'MODEL' | 'VIDEO' | 'AUDIO' | 'IMAGE';
  listId: string;
  previewImage: string;
  id: string;
  minted: string;
  name: string;
  isExternal?: boolean;
  externalUrl?: string;
  isOzone?: boolean;
  isUFC?: boolean;
  isLALIGA?: boolean;
  isNFL?: boolean;
};
